import { styled, Grid } from "@mui/material";

/***************************************
 * OVERALL
 ***************************************/
export const FormWrapper = styled(Grid)({
  display: "flex",
  padding: "28px 40px",
  alignItems: "center",
  gap: "10px",
  "@media (max-width: 1200px)": {
    padding: "28px 20px",
  },
  "@media (max-width: 960px)": {
    padding: "28px 16px",
  },
});

export const FormFrame = styled("div")({
  display: "flex",
  padding: "28px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  borderRadius: "28px",
  background: "#FFF",
  flex: "1 0 0",
  alignSelf: "stretch",
  maxWidth: "100%",
  minHeight: "calc(100vh - 56px)",
  "@media (max-width: 1200px)": {
    padding: "24px",
  },
  "@media (max-width: 960px)": {
    padding: "20px",
  },
});

export const FormFrameMobile = styled("div")({
  display: "flex",
  padding: "32px 28px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "28px",
  alignSelf: "stretch",
  borderRadius: "28px",
  background: "#FFF",
  minHeight: "calc(100vh - 128px)",
});

/***************************************
 * HEADER
 ***************************************/
export const FormHeader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  alignSelf: "stretch",
});

export const FormHeaderTextWrapper = styled("div")<{ isMobile: boolean }>(({ isMobile }) => ({
  display: "flex",
  padding: "12px 16px",
  alignItems: "center",
  gap: "8px",
  borderRadius: "4px",
  cursor: "pointer",
  ...(!isMobile && {
    "&:hover": {
      background: "#F8F9F9",
      borderRadius: "4px",
    },
  }),
}));

export const FormHeaderText = styled("div")({
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "22px",
});
export const FormHeaderTextMobile = styled("div")({
  color: "#F8F9F9",
  fontFamily: "Roobert",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "22px",
  "&:hover": {
    color: "#4E7086",
  },
});

export const FormHeaderButton = styled("div")({
  // Button
  display: "flex",
  padding: "8px 12px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  borderRadius: "20px",
  border: "1px solid #002035",
  background: "#FFF",
  cursor: "pointer",

  // Text
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "20px",

  "&:disabled": {
    border: "1px solid #9CA3A8",
    cursor: "not-allowed",
    color: "#9CA3A8",
  },

  "&:not(:disabled):active": {
    background: "#002035",
    border: "none",
    color: "#FFF",
  },

  "&:not(:disabled):not(:active):hover": {
    background: "#F8F9F9",
  },
});

/***************************************
 * CONTENT
 ***************************************/
export const FormContent = styled("div")({
  display: "flex",
  padding: "0px 40px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "28px",
  flex: "1 0 0",
  alignSelf: "stretch",
  borderRadius: "16px",
  "@media (max-width: 1200px)": {
    padding: "0px 20px",
  },
  "@media (max-width: 960px)": {
    padding: "0px 16px",
  },
});

export const FormContentTitleAndFields = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "32px",
  alignSelf: "stretch",
});
export const FormContentTitleAndFieldsMobile = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "32px",
  alignSelf: "stretch",
});

export const FormContentTitleAndFieldsWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
});

export const FormContentTitle = styled("div")({
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "39px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "47px",
  letterSpacing: "-0.78px",
});

// ------------------FIELDS------------------
export const FormContentFields = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
});

export const FormContentCountryFieldWrapper = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
});
export const FormContentCountryFieldWrapperMobile = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
});

export const FormContentNameFieldsWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  alignSelf: "stretch",
});

export const FormContentInputFieldWrapperFlex = styled("div")({
  display: "flex",
  padding: "0px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
  flex: "1 0 0",
  position: "relative",
  minWidth: 0,
});
export const FormContentInputFieldWrapperStretch = styled("div")({
  display: "flex",
  padding: "0px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
  alignSelf: "stretch",
  position: "relative",
});

export const FormContentInputField = styled("div")<{ isError: boolean }>(({ isError }) => ({
  display: "flex",
  padding: "16px",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
  borderRadius: "16px",
  background: "#F8F9F9",
  transition: "border-color 0.2s ease",
  border: "1px solid transparent",
  width: "100%",
  minWidth: 0,
  ...(isError && {
    border: "1px solid #EF4444",
    background: "#FFF6F6",
  }),
  ...(!isError && {
    "&:hover": {
      border: "1px solid #002035",
      "& .password-toggle-icon svg path": {
        stroke: "#000000 !important",
      },
    },
    "&:focus-within": {
      border: "1px solid #002035",
      "& .password-toggle-icon svg path": {
        stroke: "#000000 !important",
      },
    },
  }),
}));

export const FormContentInputFieldText = styled("input")({
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
  flex: "1 0 0",
  minWidth: 0,
  border: "none",
  outline: "none",
  background: "transparent",
  "&::placeholder": {
    color: "#BDC2C5",
    userSelect: "none",
  },
});

export const FormContentFieldCaption = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  position: "absolute",
  left: "16px",
  top: "-9px",
  background: "#FFF",
  zIndex: 1,
});

export const FormContentFieldCaptionText = styled("div")({
  color: "#5C6469",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "14px",
});

export const FormContentInputFieldError = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
});

export const FormContentInputFieldErrorText = styled("div")({
  color: "#002035",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "14px",
});

export const FormContentPasswordFieldValidationWrapper = styled("div")({
  display: "flex",
  padding: "0px",
  alignItems: "flex-start",
  alignContent: "flex-start",
  gap: "4px 8px",
  flexWrap: "wrap",
});

export const FormContentPasswordFieldValidationWrapperMobile = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "8px",
});

export const FormContentPasswordFieldValidationField = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "4px",
});

// ------------------DROPDOWN------------------
export const FormContentInputDropdown = styled("div")({
  display: "flex",
  padding: "12px 0px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "12px",

  maxHeight: "200px",
  overflowY: "auto",
  scrollbarWidth: "none", // Firefox
  msOverflowStyle: "none", // IE/Edge

  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  marginTop: "4px",
  zIndex: 1300,

  borderRadius: "0px 0px 8px 8px",
  background: "#FFF",
  boxShadow: "0px 12px 24px 0px rgba(216, 216, 218, 0.80)",
});

export const FormContentInputDropdownOptionsWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
});

export const FormContentInputDropdownOption = styled("div")({
  display: "flex",
  padding: "12px 24px",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
  cursor: "pointer",
  "&:hover": {
    background: "#F8F9F9",
  },
});

export const FormContentInputDropdownOptionText = styled("div")({
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "16px",
});

// ------------------FOOTER------------------
export const FormContentFieldsFooter = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "4px",
  alignSelf: "stretch",
});

export const FormContentFieldsFooterText = styled("div")({
  alignSelf: "stretch",
  color: "#5C6469",
  fontFamily: "Söhne",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "19px",
});

export const FormContentFieldsFooterTextUnderline = styled("span")<{ isClickable?: boolean }>(
  ({ isClickable = false }) => ({
    color: "#002035",
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    textDecorationSkipInk: "none",
    textDecorationThickness: "auto",
    textUnderlineOffset: "auto",
    textUnderlinePosition: "from-font",

    ...(isClickable && {
      cursor: "pointer",
    }),
  }),
);

export const ForgotPasswordWrapper = styled("div")({
  display: "flex",
  padding: "8px 12px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
  textDecorationLine: "underline",
  textDecorationStyle: "solid",
  textDecorationSkipInk: "none",
  textDecorationThickness: "auto",
  textUnderlineOffset: "auto",
  textUnderlinePosition: "from-font",
});

/***************************************
 * REFERRAL DISCLOSURE
 ***************************************/
export const FormReferralDisclosureWrapper = styled("div")({
  display: "flex",
  padding: "12px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
  borderRadius: "10px",
  background: "#F5F3EF",
});

export const FormReferralDisclosureTextWrapper = styled("div")({
  display: "flex",
  padding: "0px",
  alignItems: "flex-start",
  alignContent: "flex-start",
  gap: "12px 12px",
  alignSelf: "stretch",
  flexWrap: "wrap",
});

export const FormReferralDisclosureText = styled("div")({
  display: "flex",
  minWidth: "247px",
  alignItems: "center",
  gap: "8px",
  flex: "1 0 0",
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "16px",
});

/***************************************
 * CALLS TO ACTION
 ***************************************/
export const FormCallsToActionWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
});

interface ButtonWrapperProps {
  isLoading: boolean;
  background: string;
  color: string;
  fontSize: string;
  fontWeight: string;
  lineHeight: string;
  border: string;
  onHoverBackground: string;
  onHoverBoxShadow: string;
  onHoverFontWeight: string;
  onActiveBackground: string;
  onActiveBoxShadow: string;
  onActiveColor: string;
  onDisabledBackground: string;
  onDisabledBoxShadow: string;
  onDisabledBorder: string;
  onDisabledColor: string;
}
export const ButtonWrapper = styled("button", {
  shouldForwardProp: (prop) =>
    ![
      "isLoading",
      "background",
      "color",
      "fontSize",
      "fontWeight",
      "lineHeight",
      "border",
      "onHoverBackground",
      "onHoverBoxShadow",
      "onHoverFontWeight",
      "onActiveBackground",
      "onActiveBoxShadow",
      "onActiveColor",
      "onDisabledBackground",
      "onDisabledBoxShadow",
      "onDisabledBorder",
      "onDisabledColor",
    ].includes(prop as string),
})<ButtonWrapperProps>(
  ({
    isLoading,
    background,
    color,
    fontSize,
    fontWeight,
    lineHeight,
    border,
    onHoverBackground,
    onHoverBoxShadow,
    onHoverFontWeight,
    onActiveBackground,
    onActiveBoxShadow,
    onActiveColor,
    onDisabledBackground,
    onDisabledBoxShadow,
    onDisabledBorder,
    onDisabledColor,
  }) => ({
    // Button
    display: "flex",
    padding: "20px 16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    borderRadius: "28px",
    border: border || "none",
    background: background,
    cursor: "pointer",
    minHeight: "62px",

    // Text
    color: color,
    fontFamily: "Roobert",
    fontSize: fontSize,
    fontStyle: "normal",
    fontWeight: fontWeight,
    lineHeight: lineHeight,

    "&:not(:disabled):active": {
      background: onActiveBackground,
      boxShadow: onActiveBoxShadow || "none",
      border: "none",
      color: onActiveColor || color,
    },

    ...(!isLoading && {
      "&:disabled": {
        background: onDisabledBackground,
        boxShadow: onDisabledBoxShadow || "none",
        border: onDisabledBorder || "none",
        cursor: "not-allowed",
        color: onDisabledColor || color,
      },
      "&:not(:disabled):hover": {
        background: onHoverBackground,
        boxShadow: onHoverBoxShadow || "none",
        fontWeight: onHoverFontWeight || fontWeight,
      },
    }),
    ...(isLoading && {
      background: onHoverBackground,
      boxShadow: onHoverBoxShadow,
      cursor: "not-allowed",
    }),
  }),
);

export const FormGoogleButtonIconWrapper = styled("div")({
  width: "24px",
  height: "24px",
  aspectRatio: "1/1",
});

/***************************************
 * UNSUPPORTED COUNTRY
 ***************************************/
export const FormUnsupportedCountryHeaderWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "32px",
  alignSelf: "stretch",
});

export const FormUnsupportedCountryHeaderText = styled("div")<{ isMobile: boolean }>(
  ({ isMobile }) => ({
    display: "flex",
    padding: "0px",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    alignSelf: "stretch",

    color: "#002035",
    fontFamily: "Roobert",
    fontSize: "39px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "47px",
    letterSpacing: "-0.78px",
    ...(isMobile && {
      textAlign: "center",
    }),
  }),
);

export const FormUnsupportedCountryHeaderSubText = styled("div")({
  display: "flex",
  padding: "0px",
  alignItems: "flex-start",
  alignContent: "flex-start",
  gap: "12px",
  alignSelf: "stretch",
  flexWrap: "wrap",

  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "16px",
});

/***************************************
 * SUBSCRIPTION
 ***************************************/
export const FormSubscriptionHeaderWrapper = styled("div")({
  display: "flex",
  padding: "28px",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
});

export const FormSubscriptionHeaderContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",
  alignSelf: "stretch",
});

export const FormSubscriptionHeaderTextWrapper = styled("div")({
  display: "flex",
  padding: "0px",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
});

export const FormSubscriptionHeaderText = styled("div")({
  color: "#002035",
  textAlign: "center",
  fontFamily: "Roobert",
  fontSize: "28px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "34px",
  letterSpacing: "-0.56px",
});
export const FormSubscriptionHeaderTextMobile = styled("div")({
  color: "#002035",
  textAlign: "center",
  fontFamily: "Roobert",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "28px",
  letterSpacing: "-0.48px",
});

export const FormSubscriptionHeaderSubText = styled("div")({
  color: "#002035",
  textAlign: "center",
  fontFamily: "Roobert",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px",
  letterSpacing: "-0.48px",
});
export const FormSubscriptionHeaderSubTextMobile = styled("div")({
  color: "#002035",
  textAlign: "center",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
});

export const FormSubscriptionInputWrapper = styled("div")({
  display: "flex",
  padding: "40px",
  flexDirection: "column",
  alignItems: "center",
  gap: "32px",
  borderRadius: "28px",
  background: "#FFF",
  boxShadow: "0px 4px 20px 0px rgba(173, 192, 203, 0.30)",
});

export const FormSubscriptionInputTitle = styled("div")({
  alignSelf: "stretch",
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "28px",
  letterSpacing: "-0.48px",
});
export const FormSubscriptionInputTitleMobile = styled("div")({
  color: "#002035",
  textAlign: "center",
  fontFamily: "Roobert",
  fontSize: "19px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "24px",
  letterSpacing: "-0.38px",
});

export const FormSubscriptionOptionsWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
});

export const FormSubscriptionOption = styled("button")<{ isSelected: boolean }>(
  ({ isSelected }) => ({
    display: "flex",
    padding: "24px",
    alignItems: "center",
    gap: "12px",
    alignSelf: "stretch",
    borderRadius: "16px",

    border: "1px solid #E5E7E8",
    background: "#FFF",

    cursor: "pointer",

    "&:disabled": {
      cursor: "not-allowed",
    },

    "&:not(:disabled):hover": {
      border: "1px solid #0BEC9F",
      background: "#F0FEF9",
    },
    "&:not(:disabled):active": {
      border: "1px solid #0BEC9F",
      background: "#F0FEF9",
    },
    ...(isSelected && {
      border: "1px solid #0BEC9F",
      background: "#F0FEF9",
    }),
  }),
);

export const FormSubscriptionOptionTextWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  flex: "1 0 0",

  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "22px",
});
export const FormSubscriptionOptionTextWrapperMobile = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  flex: "1 0 0",

  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
});

export const FormSubscriptionOptionSubtextWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
  flex: "1 0 0",
});

export const FormSubscriptionOptionSubtext = styled("div")({
  color: "#6B7280",
  fontFamily: "Roobert",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "18px",
});

export const FormSubscriptionOptionSubtextMobile = styled("div")({
  color: "#6B7280",
  fontFamily: "Roobert",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "16px",
});

/***************************************
 * PHONE VALIDATION
 ***************************************/
export const FormPhoneValidationTextAndInputWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "32px",
  alignSelf: "stretch",
});

export const FormPhoneValidationHeaderText = styled("div")({
  display: "flex",
  padding: "0px",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "39px",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "47px",
  letterSpacing: "-0.78px",
});

/***************************************
 * LOGIN SPECIFIC STYLES
 ***************************************/
export const FormContentLeftAligned = styled(FormContent)({
  alignItems: "flex-start",
});

export const MultiAccountDescription = styled("div")({
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
  marginBottom: "24px",
});

export const MultiAccountOptionsContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "16px",
  alignSelf: "stretch",
});

export const MultiAccountOptionButton = styled("button")({
  display: "flex",
  padding: "24px",
  alignItems: "center",
  gap: "12px",
  alignSelf: "stretch",
  borderRadius: "16px",
  border: "1px solid #E5E7E8",
  background: "#FFF",
  cursor: "pointer",
  transition: "all 0.2s ease",
  width: "100%",
  "&:hover": {
    border: "1px solid #0BEC9F",
    background: "#F0FEF9",
  },
});

export const MultiAccountOptionContent = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  gap: "16px",
  flex: "1 0 0",
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "22px",
});

export const MultiAccountOptionText = styled("div")({
  flex: "1 0 0",
  textAlign: "left",
});

export const MultiAccountOptionName = styled("div")({
  fontSize: "18px",
  fontWeight: "600",
  marginBottom: "4px",
});

export const MultiAccountOptionId = styled("div")({
  fontSize: "14px",
  color: "#666",
});

export const TwoFASubtitle = styled("div")({
  color: "#002035",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "14px",
  marginTop: "4px",
});

/***************************************
 * LOADING SPINNER
 ***************************************/
export const LoadingSpinnerContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  width: "100%",
});
